<script>
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import { Map, NavigationControl, Popup } from "maplibre-gl";
  import "maplibre-gl/dist/maplibre-gl.css";
  import mapStyle from "./map-style.json";
  import CATEGORY_MAP from "./categories";

  const TOOLTIP_COLOR_MAP = JSON.parse(JSON.stringify(CATEGORY_MAP));
  TOOLTIP_COLOR_MAP[4].color = "#D2C706";

  let map;
  let mapContainer;
  export let position;

  const dispatch = createEventDispatcher();

  $: {
    if (position) {
      map.flyTo({ center: position, zoom: position.zoom });
    }
  }

  onMount(() => {
    const popup = new Popup({
      closeButton: false,
      closeOnClick: false,
    });
    map = new Map({
      container: mapContainer,
      style: mapStyle,
      center: [4.36, 50.84],
      zoom: window.innerWidth < 768 ? 10.28 : 11,
      minZoom: 9.5,
      maxZoom: 16,
      hash: true,
      maxBounds: [
        [4.0, 50.7],
        [4.7, 51.0],
      ],
      dragRotate: false,
      keyboard: false,
      touchZoomRotate: true,
      touchPitch: false,
    });
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();
    const nav = new NavigationControl({ showCompass: false });
    map.addControl(nav, "top-left");
    map.on("click", "curieuzenair", onClick);
    map.on("mouseenter", "curieuzenair", (e) => {
      map.getCanvas().style.cursor = "pointer";
      const coordinates = e.features[0].geometry.coordinates.slice();
      const no2cat = e.features[0].properties.no2cat;
      const no2 = e.features[0].properties.no2.toFixed(2).replace(/\./, ",");
      const category = TOOLTIP_COLOR_MAP.find((cat) => cat.category === no2cat);
      const html = `
        <div class="cna-map-popup">
          <div class="cna-map-popup__title">NO<sub style="font-size: 0.6em">2</sub></div>
          <div class="cna-map-popup__value" style="color: ${category.color}">${no2} <span>µg/m<sup style="font-size: 0.6em">3</sup></span></div>
        </div>
      `;

      popup.setLngLat(coordinates).setHTML(html).addTo(map);
    });
    map.on("mouseleave", "curieuzenair", () => {
      map.getCanvas().style.cursor = "";
      popup.remove();
    });
  });

  onDestroy(() => {
    map.remove();
  });

  const onClick = (e) => {
    if (!e.features) return;
    const selectedFeatures = e.features.filter((f) => f.source === "curieuzenair");
    if (!selectedFeatures.length) return;
    const feature = selectedFeatures[0];
    // Zoom to this point.
    if (map.getZoom() < 15) {
      map.flyTo({
        center: e.lngLat,
        zoom: 15,
      });
    } else {
      map.flyTo({
        center: e.lngLat,
      });
    }
    // Mark this point.
    map.setFilter("curieuzenair-selected", ["==", ["get", "cnId"], feature.properties.cnId]);
    dispatch("select", { feature });
  };
</script>

<div class="cna-map-root" id="map" bind:this={mapContainer} />

<style>
  .cna-map-root {
    width: 100%;
    height: 100%;
  }

  :global(.maplibregl-popup-content) {
    padding: 10px 15px !important;
  }

  :global(.cna-map-popup__title) {
    color: #000;
    font-size: 0.8rem;
    font-family: sans-serif;
    padding-bottom: 0.2rem;
  }

  :global(.cna-map-popup__value) {
    font-size: 1rem;
    font-weight: bold;
  }
</style>
